import React from "react";
import { formatDate } from "../../../../common/service/CommonService";
import { Column } from "../../../../Components/Common/CommonTableIndexWise";

export const CRFColumn: Column[] = [
  { key: "name", label: "CRF Name" },
  {
    key: "createddate",
    label: "Created On",
    render(value: any) {
      return formatDate(value);
    },
  },
];

export const crfModuleColumns = (onModuleClick: (row: any) => void): Column[] => [
  {
    key: "label",
    label: "Module Name",
    type: "link",
    onClick: (row: any) => onModuleClick(row),
  },
  {
    key: "categoryname",
    label: "Category",
    render: (value: any, row: any) => row.categoryname || "—",
  },
  {
    key: "createddate",
    label: "Created On",
    render(value: any) {
      return formatDate(value);
    },
  },
];

export const getAssignCRFColumns = (
  selectedIds: (number | string)[],
  toggleCRF: (row: any) => void,
  activeTab: "all" | "assigned",
  onView: (item: any) => void,
  displayedData: any[] = [],
  onToggleAllPage?: (selectAll: boolean) => void,
): Column[] => {
  const columns: Column[] = [];

  if (activeTab === "all") {
    const isAllPageSelected =
      displayedData.length > 0 &&
      displayedData.every((row: any) => {
        const id = row.crfid ?? row.id;
        return selectedIds.includes(id);
      });

    const isSomePageSelected =
      displayedData.some((row: any) => {
        const id = row.crfid ?? row.id;
        return selectedIds.includes(id);
      });

    columns.push({
      key: "selection",
      label: (
        <div className="form-check custom-checkbox">
          <input
            type="checkbox"
            className="form-check-input cursor-pointer"
            checked={isAllPageSelected}
            ref={(input) => {
              if (input) {
                input.indeterminate = !isAllPageSelected && isSomePageSelected;
              }
            }}
            onChange={(e) => onToggleAllPage?.(e.target.checked)}
          />
        </div>
      ),
      render: (_: any, row: any) => {
        const id = row.crfid ?? row.id;
        const isChecked = selectedIds.includes(id);
        return (
          <div className="form-check custom-checkbox">
            <input
              type="checkbox"
              className="form-check-input cursor-pointer"
              checked={isChecked}
              onChange={() => toggleCRF(row)}
            />
          </div>
        );
      },
      width: "60px",
    });
  }

  columns.push({
    key: "name",
    label: "CRF Name",
    render: (val: any, row: any) => (
      <a
        onClick={(e) => {
          e.preventDefault();
          if (onView) onView(row);
        }}
        className="fw-600 text-primary cursor-pointer"
        style={{ cursor: "pointer" }}
      >
        {val || row.crfname || row.crfName || row.name || "N/A"}
      </a>
    ),
  });

  columns.push({
    key: "createddate",
    label: activeTab === "assigned" ? "Assigned On" : "Created On",
    render(value: any, row: any) {
      return formatDate(value || row.createdOn || row.createddate);
    },
  });

  return columns;
};
